import React from 'react';
import { Box } from '@mui/material';

interface SoundBarsProps {
  active?: boolean;
  height?: number;
  sx?: object;
}

const BAR_HEIGHTS = [0.45, 0.85, 0.6, 0.95];
const BAR_DELAYS = [0, 0.15, 0.08, 0.22];

const BAR_CONTAINER_SX = (height: number, sx?: object) => ({
  display: 'flex',
  gap: '2px',
  height,
  width: 18,
  flexShrink: 0,
  mr: 0.5,
  ...sx,
  /** Siempre anclar al borde inferior: las barras solo crecen hacia arriba (como reproductor compacto). */
  alignItems: 'flex-end',
});

const SoundBars: React.FC<SoundBarsProps> = ({ active = true, height = 14, sx }) => {
  if (!active) {
    return <Box sx={BAR_CONTAINER_SX(height, sx)} aria-hidden />;
  }

  return (
    <Box sx={BAR_CONTAINER_SX(height, sx)}>
      {BAR_HEIGHTS.map((ratio, i) => (
        <Box
          key={i}
          sx={{
            width: 3,
            height: `${ratio * 100}%`,
            borderRadius: 1,
            backgroundColor: '#2391FF',
            transformOrigin: 'bottom',
            animation: `sonosBarPulse 0.85s ease-in-out ${BAR_DELAYS[i]}s infinite alternate`,
            '@keyframes sonosBarPulse': {
              '0%': { transform: 'scaleY(0.35)' },
              '100%': { transform: 'scaleY(1)' },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default SoundBars;
